export const pageHeaderContent = {
  certification: {
    title: "Certificações",
  },
  companies: {
    title: "Empresas",
    subtitle: `<div><span>Cadastre e edite aqui os dados de todas as Empresa.<br/></span><span style="font-weight: 600; line-height: 22px; word-wrap: break-word">Caso seja necessário contate-nos através do e-mail:  </span><span style="color: #0073BB; font-size: 14px; font-family: Raleway; font-weight: 600; text-decoration: underline; line-height: 22px; word-wrap: break-word">consultoria@geracaosocial.com.br</span></div>`,
  },
  researches: {
    title: "Questionários",
    subtitle:
      "As próximas etapas ajudarão a iniciar seu processo de configuração do questionário.",
  },
  surveyTemplate: {
    title: "Questionário base",
    subtitle: "Defina questionários base para inserir e manipular perguntas.",
  },
};
